// barcode.component.ts
import { Component, AfterViewInit, Input } from '@angular/core';
import { BarcodeService } from './BarCodeService';
import {  SafeUrl } from '@angular/platform-browser';
import { WriterOptions, WriteInputBarcodeFormat } from "zxing-wasm";
@Component({
	selector: 'app-barcode',
	template: `<img *ngIf="barcodeUrl" [src]="barcodeUrl" alt="barcode" [height]="height" />`
})
export class BarcodeComponent implements AfterViewInit {
	barcodeUrl: string | SafeUrl | null = null;
	@Input()
	height: number = 50;
	@Input()
	text: string = '';
	@Input()
	format: WriteInputBarcodeFormat = 'UPC-A';
	constructor(private barcodeService: BarcodeService) { }

	async ngAfterViewInit() {
		var options = {
			sizeHint: this.height,
			withHRT: true,
			withQuietZones: true,
			margin: 10,
			format: this.format
		} as WriterOptions;
		this.barcodeUrl = await this.barcodeService.getBarcodeSvgAsSafeUrl(this.text, options);
	}
}
